import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const LOAD_PUBLISH_TERMS_START = 'PUBLISH_TERMS :: LOAD_START';

export type TLoadPublishTermsStartAction = IReduxAction<typeof LOAD_PUBLISH_TERMS_START>;

export const loadPublishTermsStart = actionGenerator<typeof LOAD_PUBLISH_TERMS_START>(LOAD_PUBLISH_TERMS_START);
